import { ReactNode } from "react";
import React from "react";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { AGENDA_PIXELS_PER_MINUTE } from "./../../multiSlotBookingConstants";

type AgendaItemContainerProps = {
  children?: ReactNode | ReactNode[] | null;
  durationMins: number;
};

export const AgendaItemContainer = ({
  children,
  durationMins,
}: AgendaItemContainerProps) => {
  const heightInPixels = AGENDA_PIXELS_PER_MINUTE * durationMins;
  return (
    <VStack height={heightInPixels} width="100%" px={0.5} pb={1}>
      {children}
    </VStack>
  );
};
